module.exports = __webpack_public_path__ + "img/en.dc0bfbcd.svg";